import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReAuth } from './api';
import { createHeaders } from '../utils/createHeaders';

const BASE_URL = `${import.meta.env.VITE_BACKEND_URL}/api/athena/jira`;

export const apiJira = createApi({
  reducerPath: 'apiJira',
  baseQuery: (...args) => baseQueryWithReAuth(...args, { baseUrl: BASE_URL }),
  tagTypes: ['jiraIssue'],
  endpoints: (build) => ({
    getJiraIssue: build.query<any, { id: string; authKey: string }>({
      query: ({ id, authKey }) => {
        const headers = createHeaders(authKey);

        return {
          url: `/${id}`,
          method: 'GET',
          headers
        };
      },
      providesTags: ['jiraIssue']
    })
  })
});

export const { useGetJiraIssueQuery } = apiJira;
